import React from 'react';
import { Container, Row, Col, Button, } from 'react-bootstrap';
import { FaPhoneVolume } from "react-icons/fa6";
import { MdLocationOn, MdOutlineEmail } from "react-icons/md";
import { BiLogoFacebookCircle } from "react-icons/bi";
import Imgxing from '../../assets/hansa-flex-xing.png'
import Imglinkidin from '../../assets/hansa-flex-linkdin.png'
import Imgyoutube from '../../assets/hansa-flex-youtube.png'
import Imgkaggle from '../../assets/hansa-flex-kaggle.png'
import Imgfacebook from '../../assets/hansa-flex-facebook.png'
import { Link } from 'react-router-dom';
import './HfFooter.css'
import { useTranslation } from 'react-i18next';
import ContactForm from '../ContactForm/ContactForm';

import imgHANSA_FLEX_SPAIN_Catalog from '../../assets/hansa-flex-catalog.png'

import accessibility from '../../assets/policy/Accessibility-Policy-HFC.pdf';
import { getLocalizedSlug } from '../../lib/slugs';

const HfFooter = () => {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || 'en').substring(0, 2);

  return (
    <footer className='hfFooter-wrapper mt-5' id='contact-us-section'>
      <Container className='hfFooter-container'>
        <Row className="justify-content-center " style={{ marginLeft: 'auto' }}>
          <Col sm={12} lg={4} >
            <div className='footer-column-div'>
              <b>{(t('HANSA-FLEX Catalog'))}</b>
              <ul>
                <li><a href="/Connection_technology_catalogue_EN_web.pdf" target="_blank" rel="noopener noreferrer" className="footer-link"><img src={imgHANSA_FLEX_SPAIN_Catalog} alt={t("HANSA-FLEX IBÉRICA  corporate catalog")} width="50%" /></a></li>
                <li><a href="/Connection_technology_catalogue_EN_web.pdf" target="_blank" rel="noopener noreferrer" className="footer-link"> {t("HANSA-FLEX IBÉRICA  corporate catalog")} </a></li>
              </ul>
              <br />
            </div>
            <div className='footer-column-div'>
              <b>{(t("Follow us on social media"))}</b>
              <ul className='footer-social-media-ul'>
                <div className="circle-col"><a href="https://www.linkedin.com/company/hansa-flex-iberica/" target="_blank" rel="noopener noreferrer"><div><img src={Imglinkidin} alt="LinkedIn" /></div></a></div>
                <div className="circle-col"><a href="https://www.youtube.com/@HANSAFLEXIB%C3%89RICA" target="_blank" rel="noopener noreferrer"><div><img src={Imgyoutube} alt="YouTube" /></div></a></div>
                {/* <div className="circle-col"><a href="https://www.linkedin.com/company/hansa-flex-chile-s.a./" target="_blank" rel="noopener noreferrer"><div><img src={Imgfacebook} alt="" /></div></a></div> */}
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={4}>
            <div className='footer-column-div'>
              <b>{(t('Information'))}</b>
              <ul>
                <p>{t("At HANSA-FLEX IBÉRICA , we manufacture ready-to-install hydraulic and pneumatic piping systems, custom-made, with hydraulic components that are tailored to each other and a tailored logistics service.")}</p>
                <p>{t("We are a leading manufacturer of customized solutions using precision technology and offer comprehensive service programs, project planning, engineering, and modern logistics solutions.")} </p>
                <a href={`/${lang}${getLocalizedSlug('contact_us', lang)}`}><button className="submit-button">{t('SEE PHONE')}</button></a>
              </ul>

              <b>{(t('Featured'))}</b>
              <ul>
                <li><a href="https://shop.hansa-flex.es/es_ES/" target="_blank" rel="noopener noreferrer" className="footer-link">{(t('Products'))}</a></li>
                <a href="https://my.hansa-flex.es/es_ES/login" target="_blank" rel="noopener noreferrer" className="footer-link">{(t('X-CODE Manager'))}</a>
                <li><a href="https://shop.hansa-flex.es/componentes-hidr%C3%A1ulicos/c/webcat_HF_HKO" target="_blank" rel="noopener noreferrer" className="footer-link">{(t('Hydraulic Solutions'))}</a></li>
                <li><a href={`/${lang}${getLocalizedSlug('certificates', lang)}`} className="footer-link">{(t('Certificates'))}</a></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={4}>
            <div className='footer-column-div'>
            <b>{(t('Send us your query'))}</b>
              <ContactForm />
            </div>
          </Col>
        </Row>

        <div className='HfFooter-link-div'>
          <a className="hf-footer-link" href="">© {(t('Copyright All Rights Reserved'))}</a><span>  |  </span>
          <Link to={`/${lang}${getLocalizedSlug('legal_notice', lang)}`} className="footer-link">{(t('Legal Notice'))}</Link><span>  |  </span>
          <Link to={`/${lang}${getLocalizedSlug('privacy_policy', lang)}`} className="footer-link">{(t('Privacy Policy'))}</Link><span>  |  </span>
          <Link to={`/${lang}${getLocalizedSlug('general_conditions', lang)}`} className="footer-link">{(t('General Conditions of Contracting'))}</Link><span>  |  </span>
          <Link to={`/${lang}${getLocalizedSlug('terms_and_conditions', lang)}`} className="footer-link">{(t('Terms and Conditions'))}</Link><span>  |  </span>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              document.cookie = "HFCookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              window.location.reload();
            }}
            className="footer-link"          >
            {t('Manage Cookie Preferences')}
          </a>
        </div>
      </Container>
    </footer >

  );
};

export default HfFooter;
